<template>
  <div class="kye-report-echarts-bar_navigation">
    <div class="kye-report-echarts-bar_navigation_item" v-for="(item, index) in navigationData" :key="index" @click="navigationClick(item, index)">
      <img class="kye-report-echarts-bar_navigation_item_left"
        @click.stop="navigationClick(item, index, 'back')"
        v-if="item.back"
        src="../../asset/images/back.png" alt="">
      <div class="kye-report-echarts-bar_navigation_item_label" :class="[item.highlight ? 'highlight' : '']">{{ item.name }}</div>
      <img class="kye-report-echarts-bar_navigation_item_right"
        v-if="index !== navigationData.length - 1"
        src="../../asset/images/right-icon.png" @click.stop="navigationClick(item, index, 'icon-right')" alt="">
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      navigation: {
          type: Array,
          default: () => ([])
        }
    },
    data() {
      return {

      }
    },
    computed: {
      navigationData() {
        const { navigation } = this
        const lastIndex = navigation.length - 1
        return navigation.map((i, _index) => {
          const { highlight, back } = i
          return {
            ...i,
            highlight: !!(highlight || _index !== lastIndex),
            back: back || _index === 0
          }
        })
      }
    },
    methods: {
      navigationClick(item, index, type) {
        this.$parent.$emit('navigationClick', item, index, type)
      },
    }
  }
</script>

<style lang="less">
  .kye-report-echarts-bar_navigation{
    display: flex;
    align-items: center;
    height: 34px;
    padding-left: 16px;
    &_item{
      display: flex;
      align-items: center;
      &_label{
        font-size: 12px;
        color: #333333;
      }
      &_left{
        width: 12px;
        height: 12px;
        border-radius: 100%;
        margin-right: 8px;
      }
      &_right{
        width: 12px;
        height: 12px;
        margin-left:7px;
        margin-right: 12px;
      }
      .highlight{
        color: var(--g-color-primary);
        cursor: pointer;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/public/components/kye-report-form/echarts/bar-x/navigation.vue